//--------------- SELETOR DE OFERTAS DA LASTLINK NO CADASTRO DE PRODUTO ---------------//
// Lista o catálogo sincronizado em Integrações → Lastlink e deixa marcar quais ofertas são
// deste produto. O webhook usa o vínculo (Offer.Id → produto) pra casar a venda.
// Só aparece quando existe catálogo; sem ofertas, o cadastro segue igual.
import { useEffect, useState } from "react";
import lastlinkConfigService from "../../Integracoes/services/lastlinkConfigService";

export function useOfertasLastlink() {
  const [ofertas, setOfertas] = useState([]);
  useEffect(() => {
    lastlinkConfigService.ofertas().then((r) => setOfertas(r.data?.ofertas || [])).catch(() => setOfertas([]));
  }, []);
  return ofertas;
}

// Aplica a diferença entre o vínculo atual e o selecionado. Chamar depois de salvar o produto.
export async function aplicarVinculosOfertas(ofertas, produtoId, selecionadas) {
  const tarefas = [];
  for (const o of ofertas) {
    const marcada = selecionadas.has(o.id);
    if (marcada && o.produto_id !== produtoId) tarefas.push(lastlinkConfigService.vincular(o.id, produtoId));
    if (!marcada && o.produto_id === produtoId) tarefas.push(lastlinkConfigService.vincular(o.id, null));
  }
  await Promise.all(tarefas);
  return tarefas.length;
}

export default function OfertasLastlinkPicker({ ofertas, selecionadas, setSelecionadas, produtoId }) {
  if (!ofertas || ofertas.length === 0) return null;
  const toggle = (id) => {
    const s = new Set(selecionadas);
    if (s.has(id)) s.delete(id); else s.add(id);
    setSelecionadas(s);
  };
  return (
    <div className="mb-4">
      <label className="block text-xs text-ink-3 mb-1">Ofertas da Lastlink deste produto (opcional)</label>
      <div className="max-h-40 overflow-y-auto rounded border border-white/[0.08] bg-surface-1 divide-y divide-white/[0.04]">
        {ofertas.map((o) => {
          const deOutro = o.produto_id && o.produto_id !== produtoId && !selecionadas.has(o.id);
          return (
            <label key={o.id} className={`flex items-center gap-2 px-3 py-2 text-xs cursor-pointer ${deOutro ? "opacity-60" : ""}`}>
              <input type="checkbox" checked={selecionadas.has(o.id)} onChange={() => toggle(o.id)} className="accent-brand-500" />
              <span className="text-ink-1 truncate">{o.titulo || "(sem título)"}</span>
              <span className="text-ink-4 font-mono">{o.code || ""}</span>
              {deOutro && <span className="ml-auto text-[10px] text-ink-4 truncate">já em: {o.produto_nome || `#${o.produto_id}`}</span>}
            </label>
          );
        })}
      </div>
      <p className="text-[11px] text-ink-4 mt-1">Marcar uma oferta que já está em outro produto move o vínculo para este.</p>
    </div>
  );
}
